export class Question {
  Title: string;
  Body: string;
  Type?: string;
  IsSelected?: boolean;
}
